export const productDatas = [
  {
    id: "01H3SKM8JCMSY6VJ7F3S0K75F6",
    name: "Netflix Premium subscription",
    photo:
      "https://cdn.thelivemirror.com/wp-content/uploads/2021/06/Subscription_TLM.jpg",
    category: "Subscription",
    visibiity: "public",
    slug: "",
    customerInput: [
      {
        type: "text",
        title: "In Game Name",
      },
      {
        type: "number",
        title: "In Game Id",
      },
    ],
    isPopular: true,
    productInfo: [
      { title: "3  fsMonths", price: 33333, stock: "Available" },
      { title: "6faf Months", price: 5333, stock: "Available" },
      { title: "9 Months", price: 33543, stock: "Available" },
      { title: "12  fsMonths", price: 3333, stock: "Available" },
    ],
    description: "Premium subscription of Netflix is provided here",
  },
  {
    id: "01H3SKM8JJQCW9Z14BFF9MTFED",
    name: "Premium subscription of Disney+",
    photo:
      "https://images.livemint.com/img/2020/11/13/1600x900/hotstar_1592581170738_1592581198421_1605241310031.jpeg",
    category: "Gift Card",
    visibiity: "public",
    slug: "",
    customerInput: [
      {
        type: "text",
        title: "In Game Name",
      },
      {
        type: "number",
        title: "In Game Id",
      },
    ],
    isPopular: false,
    productInfo: [
      {
        title: "1 Year",
        price: 665,
        stock: "Available",
      },
      {
        title: "6 month",
        price: 365,
        stock: "Available",
      },
      {
        title: "1 Year",
        price: 665,
        stock: "Available",
      },
      {
        title: "6 month",
        price: 365,
        stock: "Available",
      },
      {
        title: "1 Year",
        price: 665,
        stock: "Available",
      },
      {
        title: "6 month",
        price: 365,
        stock: "Available",
      },
    ],
    description: "Premium subscription of Disney+ is provided here",
  },
  {
    id: "01H3SKM8JP3WY2Z60SWS60HPF5",
    name: "Apple iTune Gift Card",
    photo:
      "https://gadgetbd.com/wp-content/uploads/2021/02/iTunes-Card-Files-US.jpg",
    category: "Gift Card",
    visibiity: "public",
    slug: "",
    customerInput: [
      {
        type: "text",
        title: " Game Name",
      },
      {
        type: "number",
        title: " Game Id",
      },
    ],
    isPopular: false,
    productInfo: [
      {
        title: "$4.99 with basic plan",
        price: 546,
        stock: "Available",
      },
      {
        title: "$9.99 with basic plan",
        price: 1046,
        stock: "Available",
      },
    ],
    description:
      "Get a $100 Apple iTun gift card for your favorite online store",
  },
  {
    id: "01H3SKM8JTHYVZFB3G17YBFGT9",
    name: "Premium subscription of Netflix",
    photo: "https://i.ibb.co/26gYSSw/Shariar-Hasan-05-jpg.jpg",
    category: "Gift Card",
    visibiity: "public",
    slug: "",
    customerInput: [
      {
        type: "text",
        title: "In Game Name",
      },
      {
        type: "number",
        title: "In Game Id",
      },
    ],
    isPopular: false,

    productInfo: [
      {
        title: "6 months subscription",
        price: 8655,
        stock: "Available",
      },
    ],
    description: "Purchase diamonds and get exclusive in-game items",
  },
  {
    id: "01H3SK4V5RM8JVG6Q4KWT4F6V9",
    name: "PUBG Games",
    photo: "./banners/slider2.jpg",
    category: "PUBG",
    visibiity: "public",
    slug: "",
    customerInput: [
      {
        type: "text",
        title: "In Game Name",
      },
      {
        type: "number",
        title: "In Game Id",
      },
    ],
    isPopular: true,
    productInfo: [
      {
        title: "15 UC",
        price: 3604,
        stock: "Available",
      },
      {
        title: "10 UC",
        price: 3064,
        stock: "Unavailable",
      },
      {
        title: "120 UC",
        price: 6034,
        stock: "Available",
      },
      {
        title: "1230 UC",
        price: 346,
        stock: "Available",
      },
      {
        title: "3120 UC",
        price: 3446,
        stock: "Unavailable",
      },
      {
        title: "2231 UC",
        price: 4463,
        stock: "Available",
      },
    ],
    description: "Subscribe to our OTT service and enjoy ad-free streaming",
  },
  {
    id: "01H3SKM8JVG6Q4KWT4V5R4F6V9",
    name: "PUBG KR Version",
    photo: "/banners/slider1.jpg",
    category: "PUBG",
    visibiity: "public",
    slug: "",
    customerInput: [
      {
        type: "text",
        title: "In Game Name",
      },
      {
        type: "number",
        title: "In Game Id",
      },
    ],
    isPopular: true,

    productInfo: [
      {
        title: "15 UC",
        price: 3604,
        stock: "Available",
      },
      {
        title: "10 UC",
        price: 3064,
        stock: "Available",
      },
      {
        title: "120 UC",
        price: 6034,
        stock: "Available",
      },
      {
        title: "1230 UC",
        price: 346,
        stock: "Unavailable",
      },
      {
        title: "3120 UC",
        price: 3446,
        stock: "Available",
      },
      {
        title: "2231 UC",
        price: 4463,
        stock: "Unavailable",
      },
    ],
    description: "Subscribe to our OTT service and enjoy ad-free streaming",
  },
  {
    id: "01H3SKM8K4VGKF334XCFZ60M13",
    name: "Premium subscription of Netflix",
    photo:
      "https://cdn.thelivemirror.com/wp-content/uploads/2021/06/Subscription_TLM.jpg",
    category: "Subscription",
    visibiity: "public",
    slug: "",
    customerInput: [
      {
        type: "text",
        title: "In Game Name",
      },
      {
        type: "number",
        title: "In Game Id",
      },
    ],
    isPopular: false,
    productInfo: [
      {
        title: "1 month basic plan",
        price: 122,
        stock: "Available",
      },
      {
        title: "6 months basic plan",
        price: 4122,
        stock: "Available",
      },
      {
        title: "12 months basic plan",
        price: 8122,
        stock: "Available",
      },
    ],
    description: "Subscribe to our OTT service and enjoy ad-free streaming",
  },
  {
    id: "01H3SKM8K9126DRGC13BVHK3M0",
    name: "200 UC PUBG Games",
    photo: "http://dummyimage.com/437x241.png/ff4444/ffffff",
    category: "Others",
    visibiity: "public",
    slug: "",
    customerInput: [
      {
        type: "text",
        title: "In Game Name",
      },
      {
        type: "number",
        title: "In Game Id",
      },
    ],
    isPopular: false,

    productInfo: [
      {
        title: "15 UC",
        price: 3604,
        stock: "Available",
      },
      {
        title: "10 UC",
        price: 3064,
        stock: "Available",
      },
      {
        title: "120 UC",
        price: 6034,
        stock: "Available",
      },
      {
        title: "1230 UC",
        price: 346,
        stock: "Available",
      },
      {
        title: "3120 UC",
        price: 3446,
        stock: "Available",
      },
      {
        title: "2231 UC",
        price: 4463,
        stock: "Available",
      },
    ],
    description: "Subscribe to our OTT service and enjoy ad-free streaming",
  },
];
